"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
class StdGridForm extends webix_jet_1.JetView {
    constructor(app, name, conf) {
        super(app, name);
        this.moduleName = conf.moduleName;
        this.firstFocusField = conf.firstFocusField;
    }
    reload() {
        this.currentGrid.clearAll();
        this.currentGrid.load(this.currentGrid.config.url);
    }
    enregistrer() {
        if (this.currentForm.validate()) {
            this.lastAction = "";
            var values = this.currentForm.getValues();
            if (values.id > 0) { // values.id existe uniquement en cas de modification
                this.currentGrid.updateItem(values.id, values);
                this.currentGrid.select(values.id);
                this.currentGrid.showItem(values.id);
            }
            else {
                this.currentGrid.add(values);
            }
            this.setEditMode(false);
            this.locked = false;
            $$("deconnexionButton").enable();
            // this.currentGrid.refresh();
        }
    }
    supprimer() {
        let currentId = this.currentGrid.getSelectedId();
        let suivant = this.currentGrid.getNextId(currentId);
        let precedent = this.currentGrid.getPrevId(currentId);
        this.currentGrid.remove(currentId.row);
        if (suivant) {
            this.currentGrid.select(suivant);
        }
        else if (precedent) {
            this.currentGrid.select(precedent);
        }
    }
    supprimerFiche() {
        let me = this;
        // const _ = this.app.getService("locale")._;
        let promise = webix.confirm({
            title: (0, globals_1._)("Confirmation"),
            text: (0, globals_1._)("Veuillez confirmer la suppression de cette fiche"),
            cancel: (0, globals_1._)("Annuler"),
            ok: (0, globals_1._)("OK")
        });
        promise.then(function (result) {
            if (result) {
                me.supprimer();
            }
        });
    }
    modifier() {
        let me = this;
        me.lastSelectedId = me.currentGrid.getSelectedId();
        if (me.lastSelectedId) {
            let unid = me.currentGrid.getSelectedItem().unid;
            globals_1.lv2.trace("Demande de verrou sur un enregistrement avec id : " + unid);
            // @ts-ignore
            let promise = webix.ajax().get(globals_1.phpPath + me.backend + "?option=lock&unid=" + unid);
            promise.then(function (result) {
                if (result.json().success == false) {
                    me.forcerVerrou(unid, result);
                    return;
                }
                globals_1.lv2.trace("Verrou posé");
                me.read(unid);
            });
            promise.catch(function () {
                webix.alert((0, globals_1._)("Erreur de verrouillage de la fiche"));
            });
        }
        else {
            webix.alert((0, globals_1._)("Veuillez sélectionner l'enregistrement à modifier"));
        }
    }
    read(unid) {
        let me = this;
        // @ts-ignore
        let promise2 = webix.ajax().get(globals_1.phpPath + me.backend + "?option=read&unid=" + unid);
        promise2.then(function (result) {
            if (result.json().success == false) {
                webix.alert(result.json().message);
                this.deverrou();
                return;
            }
            // mettre à jour la datatable sans provoquer d'enregistrement
            webix.dp(me.currentGrid).ignore(() => {
                me.currentGrid.updateItem(me.lastSelectedId, result.json());
            });
            me.locked = true;
            $$("deconnexionButton").disable();
            me.setEditMode(true);
        });
        promise2.catch(function () {
            webix.alert((0, globals_1._)("Erreur de relecture de la fiche"));
        });
    }
    forcerVerrou(idDoc, result) {
        let me = this;
        webix.confirm({
            title: (0, globals_1._)("Demande de verrou"),
            text: result.json().message,
            cancel: (0, globals_1._)("Forcer le verrou"),
            ok: (0, globals_1._)("Annuler")
        }).then(function () {
            // me.reload();
        }).catch(function () {
            // @ts-ignore
            let promise = webix.ajax().get(globals_1.phpPath + me.backend + "?option=lock&unid=" + idDoc + "&force=1");
            promise.then(function (result) {
                if (result.json().success == false) {
                    me.forcerVerrou(idDoc, result);
                    return;
                }
                else {
                    globals_1.lv2.trace("Verrou forcé");
                    // relecture de la fiche
                    me.read(idDoc);
                }
            });
            promise.catch(() => {
                webix.alert((0, globals_1._)("Erreur sur demande de forcer verrou"));
                return;
            });
        });
    }
    deVerrou() {
        let unid = this.currentGrid.getSelectedItem().unid;
        globals_1.lv2.trace("Demande de dé-verrou sur un enregistrement avec id : " + unid);
        // @ts-ignore
        let promise = webix.ajax().get(globals_1.phpPath + this.backend + "?option=unlock&unid=" + unid);
        promise.then(function (result) {
            if (result.json().success == false) {
                webix.alert(result.json().message);
                return;
            }
        });
        this.locked = false;
        $$("deconnexionButton").enable();
    }
    annuler() {
        if (this.lastAction == "create") {
            this.lastAction = "";
            this.setEditMode(false);
            this.currentForm.clear();
            this.currentForm.clearValidation();
            if (this.lastSelectedId)
                this.currentGrid.select(this.lastSelectedId);
            return;
        }
        if (this.lastAction == "abortCreate") {
            this.lastAction = "";
            this.setEditMode(false);
            this.currentForm.clear();
            this.currentForm.clearValidation();
            if (this.lastSelectedId)
                this.currentGrid.select(this.lastSelectedId);
            return;
        }
        this.deVerrou();
        this.currentGrid.undo();
        // this.currentForm.setValues(this.currentForm.getCleanValues());
        this.setEditMode(false);
        this.currentForm.clearValidation();
    }
    creer() {
        this.lastAction = "create";
        this.lastSelectedId = this.currentGrid.getSelectedId();
        this.currentGrid.clearSelection();
        this.setEditMode(true);
        this.currentForm.clear();
        this.currentForm.clearValidation();
        this.setDefaultValues();
        this.currentForm.focus($$(this.firstFocusField));
    }
    setEditMode(bool) {
        let menu = $$("stdGridFormMenu");
        if (bool) {
            this.leftPane.disable();
            menu.showMenuItem("enregistrerButton");
            menu.showMenuItem("annulerButton");
            menu.hideMenuItem("creerButton");
            menu.hideMenuItem("supprimerButton");
            menu.hideMenuItem("modifierButton");
            Object.values(this.currentForm.elements).forEach(val => {
                // @ts-ignore
                val.enable();
            });
        }
        else {
            this.leftPane.enable();
            menu.hideMenuItem("enregistrerButton");
            menu.hideMenuItem("annulerButton");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".insert,"))
                menu.showMenuItem("creerButton");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".delete,"))
                menu.showMenuItem("supprimerButton");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".update,"))
                menu.showMenuItem("modifierButton");
            Object.values(this.currentForm.elements).forEach(val => {
                // @ts-ignore
                val.disable();
            });
        }
    }
    ready() {
        let grid = this.currentGrid;
        grid.showOverlay("<h2>" + (0, globals_1._)("Chargement en cours ...") + "</h2>");
        let me = this;
        this.setEditMode(true);
        this.setEditMode(false);
        grid.attachEvent("onItemClick", function (id) {
            me.lastSelectedUnid = grid.getSelectedItem().unid;
        });
        grid.attachEvent("onAfterLoad", function () {
            // application du cookie de mise en forme de la grid
            let v2 = "state" + grid.config.id;
            let state = webix.storage.local.get(v2);
            // webix.message(state.ids[1]);
            if (state)
                this.setState(state);
            // sélection du dernier enregistrement sélectionné
            if (me.lastSelectedUnid > 0) {
                var res = grid.find(function (obj) {
                    return obj.unid == me.lastSelectedUnid;
                });
                for (var i = 0; i < res.length; i++)
                    grid.select(res[i].id);
            }
            this.hideOverlay();
        });
        grid.attachEvent("onBeforeLoad", function () {
            this.showOverlay("<h2>" + (0, globals_1._)("Chargement en cours ...") + "</h2>");
        });
    }
    setDefaultValues() {
        if (this.defaultValues) {
            this.currentForm.setValues(this.defaultValues);
        }
    }
    tune(tuner) {
        if (tuner.defaultValues) {
            this.defaultValues = tuner.defaultValues;
        }
        if (tuner.validation) {
            let xx = tuner.validation;
            for (let i = 0; i < xx.length; i++) {
                let yy = xx[i];
                // @ts-ignore
                this.$$(yy.fieldName).define({
                    validate: eval(yy.validator),
                    invalidMessage: (0, globals_1._)(yy.invalidMessage)
                });
            }
            this.currentForm.refresh();
        }
    }
    confirmExit() {
        return webix.confirm({
            title: (0, globals_1._)("Les données ne sont pas enregistrées."),
            text: (0, globals_1._)("Voulez-vous quitter quand même ?"),
            ok: (0, globals_1._)("Oui"),
            cancel: (0, globals_1._)("Non")
        });
    }
    exit() {
        let me = this;
        return new Promise(function (resolve, reject) {
            me.confirmExit().then(function () {
                if (me.locked) {
                    me.deVerrou();
                }
                resolve(0);
            }).catch(function () {
                globals_1.lv2.trace("On reste ici");
                let menuGauche = $$("menu");
                menuGauche.blockEvent();
                menuGauche.select("clients", false);
                menuGauche.unblockEvent();
            });
        });
    }
}
exports.default = StdGridForm;
